import React from "react";
import { Card } from "../card/card.component";
import './card-list.style.css';

export const CardList = props => {

    console.log(props);
    return <div className="card-list">
        {
            props.puppys.map(puppy=>
            <Card key={puppy.id} puppy={puppy}/>)
          }
</div>;
}